var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"process_forms",attrs:{"id":"processforms"}},[_c('ProcessesOrgChart',{key:_vm.refresh_org_charts,attrs:{"standard":_vm.standards,"roles":_vm.allRoles,"departments":_vm.departments,"allProcesses":_vm.processes,"view":_vm.view},on:{"refresh":_vm.refresh,"update_view":_vm.update_view}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }